import { TFunction } from 'i18next';

// Auth-related error codes the backend attaches to HttpError so the
// frontend can show a translated, user-facing message instead of the raw
// (English-only) error string -- shared by Login.tsx and Signup.tsx.
const KNOWN_AUTH_ERROR_CODES = new Set([
    'INVALID_CREDENTIALS',
    'ACCOUNT_EXISTS',
    'INVALID_IDENTITY_TOKEN',
    'EMAIL_NOT_SHARED',
    'CLUB_NOT_FOUND',
    'INVITE_REQUIRED',
]);

export function getAuthErrorMessage(error: any, t: TFunction, fallbackKey = 'common.genericError'): string {
    const code = error?.data?.code;

    if (typeof code === 'string' && KNOWN_AUTH_ERROR_CODES.has(code)) {
        return t(`authErrors.${code}`);
    }

    return t(fallbackKey);
}
